export const projectPermissionTypes = {
  MANAGE: 'manage',
  EDIT: 'edit',
  TRANSLATE: 'translate',
  VIEW: 'view',
};
